import ConfigureCard from './configure-card.connect'

export default ConfigureCard
